<template>
	<div class="h1-wrapper">
		<h1 class="hh1">
			<slot></slot>
		</h1>
	</div>
</template>

<script>
export default {
	name: 'Hh1',
}
</script>

<style lang="scss" scoped>
.hh1 {
	margin: 0 0 14px;
	font-size: clamp(1.8rem, 3vw, 2.4rem);
	color: #16323a;
	font-weight: 800;
	line-height: 1.25;
}
</style>
